import Repository from '../Repository';
import dateUtils from "@/utils/dateUtils";

export default {

	addPapers(batchId, paperIds) {
		var response = Repository.put('Batch/UpdateBatch', {
			batchId: batchId,
			newPaperIdsCsv: paperIds.join(',')
		});
		return response;
	},

	allocateBatch(userRoleId, batchId) {
		var response = Repository.post('Batch/AllocateBatch', {
			userRoleId: userRoleId,
			batchId: batchId,
		});
		return response;
	},

	createPaperBatch(paperIds) {
		var response = Repository.post('Batch/CreatePaperBatch', {
			paperIdCsv: (paperIds == null) ? null : paperIds.join(',')
		});
		return response;
	},

	deallocateBatch(batchId) {
		var response = Repository.put('Batch/DeallocateBatch', {
			batchId: batchId
		});
		return response;
	},

	deleteBatch(batchId) {
		var response = Repository.put('Batch/DeleteBatch', {
			batchId: batchId
		});
		return response;
	},	

	getAllBatchStatuses() {
		var response = Repository.get('Batch/GetAllBatchStatuses', {});
		return response;
	},

	getBatchCoverPage(batchId) {

		var response = Repository.get('Batch/GetBatchCoverPage', {
			responseType: 'arraybuffer',
            headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/pdf'
            },					
			params: {
				batchId: batchId
			}
		});
		return response;
	},

	getBatchPapers(pageSize, pageNumber, studentSearchString, markerSearchString, batchCodeSearchString, userRoleIds, 
			periodIds, subPeriodIds, qualificationIds, subjectIds, assessmentTypeIds, assessmentCodeIds, 
			paperBatchStatusIds, markingTypeIds, olderThanDays, youngerThanDays, statusChangeDate, submissionDate,
			allocated) {

		let statusChangeRange = {
			timeStart: null,
			timeEnd: null
		};
		if (statusChangeDate != null) {
			statusChangeRange = dateUtils.dateToUnixUTCDayRange(statusChangeDate);
		}

		let submissionRange = {
			timeStart: null,
			timeEnd: null
		};
		if (submissionDate != null) {
			submissionRange = dateUtils.dateToUnixUTCDayRange(submissionDate);
		}		

		var response = Repository.get('Batch/GetBatchPapers', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,				
				studentSearchString: studentSearchString,
				markerSearchString: markerSearchString,
				batchCodeSearchString: batchCodeSearchString,
				RoleIdCSV: (userRoleIds == null) ? null : userRoleIds.join(','),
				PeriodIdCSV: (periodIds == null) ? null : periodIds.join(','),
				SubPeriodIdCSV: (subPeriodIds == null) ? null : subPeriodIds.join(','),
				QualificationIdCSV: (qualificationIds == null) ? null : qualificationIds.join(','),
				SubjectIdCSV: (subjectIds == null) ? null : subjectIds.join(','),
				AssessmentTypeIdCSV: (assessmentTypeIds == null) ? null : assessmentTypeIds.join(','),
				AssessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
				PaperBatchStatusIdCSV: (paperBatchStatusIds == null) ? null : paperBatchStatusIds.join(','),
				MarkingTypeIdCsv: (markingTypeIds == null) ? null : markingTypeIds.join(','),
				OlderThanDays: (olderThanDays <= 0) ? null : olderThanDays,
				YoungerThanDays: (youngerThanDays <= 0) ? null : youngerThanDays,
				StatusChangeDateStart: statusChangeRange.startTime,
				StatusChangeDateEnd: statusChangeRange.endTime,
				MarkCompletionDateStart: submissionRange.startTime,
				MarkCompletionDateEnd: submissionRange.endTime,
				orderDirection: 'desc',
				allocated: allocated	
			}
		});
		return response;
	},

	
	getBatchPapersCsv(studentSearchString, markerSearchString, batchCodeSearchString, userRoleIds, 
		periodIds, subPeriodIds, qualificationIds, subjectIds, assessmentTypeIds, assessmentCodeIds, 
		paperBatchStatusIds, markingTypeIds, olderThanDays, youngerThanDays, statusChangeDate, submissionDate,
		allocated) {

		let statusChangeRange = {
			timeStart: null,
			timeEnd: null
		};
		if (statusChangeDate != null) {
			statusChangeRange = dateUtils.dateToUnixUTCDayRange(statusChangeDate);
		}

		let submissionRange = {
			timeStart: null,
			timeEnd: null
		};
		if (submissionDate != null) {
			submissionRange = dateUtils.dateToUnixUTCDayRange(submissionDate);
		}		

		var response = Repository.get('Batch/GetBatchPapersCsv', {
			params: {
				Csv: true,			
				studentSearchString: studentSearchString,
				markerSearchString: markerSearchString,
				batchCodeSearchString: batchCodeSearchString,
				RoleIdCSV: (userRoleIds == null) ? null : userRoleIds.join(','),
				PeriodIdCSV: (periodIds == null) ? null : periodIds.join(','),
				SubPeriodIdCSV: (subPeriodIds == null) ? null : subPeriodIds.join(','),
				QualificationIdCSV: (qualificationIds == null) ? null : qualificationIds.join(','),
				SubjectIdCSV: (subjectIds == null) ? null : subjectIds.join(','),
				AssessmentTypeIdCSV: (assessmentTypeIds == null) ? null : assessmentTypeIds.join(','),
				AssessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
				PaperBatchStatusIdCSV: (paperBatchStatusIds == null) ? null : paperBatchStatusIds.join(','),
				MarkingTypeIdCsv: (markingTypeIds == null) ? null : markingTypeIds.join(','),
				OlderThanDays: (olderThanDays <= 0) ? null : olderThanDays,
				YoungerThanDays: (youngerThanDays <= 0) ? null : youngerThanDays,
				StatusChangeDateStart: statusChangeRange.startTime,
				StatusChangeDateEnd: statusChangeRange.endTime,
				MarkCompletionDateStart: submissionRange.startTime,
				MarkCompletionDateEnd: submissionRange.endTime,
				orderDirection: 'asc',
				allocated: allocated	
			}
		});
		return response;
	},

	getMarkerBatchAllocations(pageSize, pageNumber, searchString) {
		var response = Repository.get('Batch/GetMarkerBatchAllocations', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,				
				searchString: searchString,
				orderDirection: 'desc'	
			}
		});
		return response;
	},

	getRecentlyMarkedBatches(pageSize, pageNumber) {
		var response = Repository.get('Batch/GetRecentlyMarkedBatches', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,
				orderDirection: 'desc'	
			}
		});
		return response;
	},

	issueBatchRemark(batchId) {
		var response;
		response = Repository.put('Batch/IssueBatchRemark', {
			batchId: batchId,
		});
		return response;
	},

	receiveBatch(batchId) {
		var response = Repository.put('Batch/ReceiveBatch', {
			batchId: batchId
		});
		return response;
	},

	regenerateCoverPage(batchId) {
		var response = Repository.put('Batch/RegenerateCoverPage', {
			batchId: batchId
		});
		return response;
	},

	removePaper(batchId, paperId) {
		var response = Repository.put('Batch/UpdateBatch', {
			batchId: batchId,
			removePaperIdsCsv: paperId + ''
		});
		return response;
	},

	submitBatch(batchId) {
		var response = Repository.post('Batch/SubmitBatch', {
			batchId: batchId
		});
		return response;
	},
	
	unreceiveManualComponent(paperId) {
		var response = Repository.put('Batch/UnreceiveManualComponent', {
			paperIdsCsv: paperId + ''
		});
		return response;
	},

}
